/**
 * @author Ariel
 * @Date 2022-12-08
 */
import React from "react";
import {connect} from "dva";
import {templateConfig,reduxTemplateConfig} from "./config";
import {component_tool, framework_tool, utils_tool} from '../../../../tool';
import {Descriptions} from "antd";

let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport, WizCard} = component_tool
let { Session } = utils_tool

const _getValue = (type, key) => {
  const values = {
    pass: {
      0: '未通过',
      1: '已通过',
    },
    programStatus: {
      0: '草稿',
      1: '发布',
      2: '状态'
    }
  };
  return values[type][key]
};

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
      if (history.location.record) {
        record = history.location.record
        Session.set('programInfo', record)
      } else {
        record = Session.get('programInfo') || {}
      }
  }
  return record
}

class LearningRecordManager extends WizContainer {
  componentName = 'LearningRecordManager';

  constructor(props){
    super(props);
    let record = getParamRecord(props.history)
    this.state = {
      record: record
    }
  };

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '学员帐号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '学员姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '任职信息',
        field: 'identityListInfo',
        width: 35,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '学习进度',
        field: 'finishRate',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '通过状态',
        field: 'pass',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '完成时间',
        field: 'completedDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '最后学习时间',
        field: 'lastTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e.identityListInfo = e.identityLists && e.identityLists.map(t => t.areaName + '>' + t.orgName + '-' + t['positionName']).join(',') || ''
        e.pass = _getValue('pass', e.pass)
        e.finishRate = e.finishRate + '%'
      })
      WizBrowserExport({
        title: '课程学习记录信息',
        sheetName: '课程学习记录信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '课程学习记录信息.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    const { record } = this.state
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig({programInfo:record}),
      apiDataFormat: {
        export: this._handleFile,
      },
      record: record
    })
    return (
      <React.Fragment>
        <WizCard title={'课程信息'}>
          <Descriptions column={2} style={{paddingLeft: 25}}>
            <Descriptions.Item label='课程名称'>{record.name}</Descriptions.Item>
            <Descriptions.Item label='课程编码'>{record.scoId}</Descriptions.Item>
            <Descriptions.Item label='课程分类'>{record.programCategoryNames}</Descriptions.Item>
            <Descriptions.Item label='课程状态'>{_getValue("programStatus",record.status)}</Descriptions.Item>
          </Descriptions>
        </WizCard>
        <WizCard title={'学习记录'}>
          <WizReduxTemplate {..._reduxTemplateConfig}/>
        </WizCard>
      </React.Fragment>
    )
  }
};

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(LearningRecordManager);
